<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
body {
  margin: 0;
  height: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: pingfang SC, helvetica neue, arial, hiragino sans gb, microsoft yahei ui, microsoft yahei, simsun, sans-serif !important;
}

label {
  font-weight: 700;
}

html {
  height: 100%;
  box-sizing: border-box;
}

#app {
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

.el-image-viewer__mask {
  opacity: 0.85 !important;
}

/* windows 默认 */
@font-face {
  font-family: MicrosoftYaHei;
  src: local('MicrosoftYaHei');
}

/* mac 默认 */
@font-face {
  font-family: PingFangSC;
  src: local('PingFangSC-Regular');
}

@font-face {
  /* 细体 */
  font-family: SourceHanSerifCN-ExtraLight;
  src: local('SourceHanSerifCN-ExtraLight'), url('@/font/SourceHanSerifCN-ExtraLight.woff') format('woff');
}

@font-face {
  /* 常规 */
  font-family: SourceHanSerifCN-Regular;
  src: local('SourceHanSerifCN-Regular'), url('@/font/SourceHanSerifCN-Regular.woff');
}

@font-face {
  /* 粗体 */
  font-family: SourceHanSerifCN-Bold;
  src: local('SourceHanSerifCN-Bold'), url('@/font/SourceHanSerifCN-Bold.woff') format('woff');
}

@font-face {
  /* 很粗体 */
  font-family: SourceHanSerifCN-Heavy;
  src: local('SourceHanSerifCN-Heavy'), url('@/font/SourceHanSerifCN-Heavy.woff') format('woff');
}


@keyframes arrowDown {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(6px);
    }
    100% {
        transform: translateY(0);
    }
}
</style>
